<template>
  <span class="download-plugin-icon" aria-hidden="true">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M12.101562,14L3.8984375,14C2.8515625,14,2,13.184375,2,12.182813L2,11C2,10.5859375,2.3359375,10.25,2.75,10.25C3.1640625,10.25,3.5,10.5859375,3.5,11L3.5,12.182813C3.5,12.354688,3.6828125,12.5,3.8984375,12.5L12.101562,12.5C12.317187,12.5,12.5,12.354688,12.5,12.182813L12.5,11C12.5,10.5859375,12.835938,10.25,13.25,10.25C13.664062,10.25,14,10.5859375,14,11L14,12.182813C14,13.184375,13.148438,14,12.101562,14ZM8,2C7.5859375,2,7.25,2.3359375,7.25,2.75L7.25,9.5C7.25,9.9140625,7.5859375,10.25,8,10.25C8.4140625,10.25,8.75,9.9140625,8.75,9.5L8.75,2.75C8.75,2.3359375,8.4140625,2,8,2Z"
        fill="currentColor"
      />
      <path
        d="M9.817174892968751,7.40478515625C9.62498759296875,7.40478515625,9.43280029296875,7.47822284725,9.28748699296875,7.62509775625L7.9999875929687505,8.91103505625L6.71405029296875,7.62509775625C6.42030048296875,7.33134794225,5.94686269296875,7.33134794225,5.65311289296875,7.62509775625C5.35936307896875,7.91884755625,5.35936307896875,8.39228486625,5.65311289296875,8.68603565625L7.47030069296875,10.50322295625C7.7640504929687495,10.79697275625,8.23748779296875,10.79697275625,8.53123859296875,10.50322295625L10.34842589296875,8.68603565625C10.642175692968749,8.39228582625,10.642175692968749,7.91884803625,10.34842589296875,7.6250982262499996C10.19998839296875,7.47822332425,10.00780109296875,7.40478563308716,9.817174892968751,7.40478515625Z"
        fill="currentColor"
      />
    </svg>
  </span>
</template>

<script>
export default {
  name: "DownloadPluginIcon",
};
</script>

<style lang="scss" scoped>
.download-plugin-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: inherit;
  line-height: 0;
  svg {
    display: block;
    min-width: 16px;
    min-height: 16px;
    width: 16px;
    height: 16px;
  }
}
</style>
